import type { NavigationGuard } from "vue-router";
import {
  loadAllAssetsDataOnce,
  isAlbumSlugChainValid,
  isAssetSlugValid,
  buildNotFoundTarget,
} from "@/router/guards/utils";
import { languagesModule } from "@/store";

const extractAlbumSegments = (param: any): string[] => {
  if (!param) return [];

  if (Array.isArray(param)) {
    return param.filter(Boolean);
  }

  if (typeof param === "string") {
    return param === "" ? [] : param.split("/").filter(Boolean);
  }

  return [];
};

const resolveTargetLang = (to: any): string => {
  const raw = to.params.locale as string | undefined;
  const languages = languagesModule.getLanguages;
  const defaultLang = (languages[0]?.code || "en") as string;

  return raw && raw !== defaultLang ? raw : defaultLang;
};

export const albumAssetGuard: NavigationGuard = async (to, _from, next) => {
  try {
    const isAssetView = to.name === "3d-viewer/albums/asset";
    const isAlbumView = to.name === "3d-viewer/albums";

    if (!isAlbumView && !isAssetView) {
      return next();
    }

    const targetLang = resolveTargetLang(to);
    await loadAllAssetsDataOnce(targetLang);

    const albumSegments = extractAlbumSegments(to.params.albumPath);

    if (!albumSegments.length) {
      if (isAssetView) {
        return next(buildNotFoundTarget(to));
      }

      return next();
    }

    if (!isAlbumSlugChainValid(albumSegments)) {
      return next(buildNotFoundTarget(to));
    }

    if (isAssetView) {
      const assetSlug = to.params.assetSlug as string | undefined;

      if (!assetSlug || !isAssetSlugValid(albumSegments, assetSlug)) {
        return next(buildNotFoundTarget(to));
      }
    }

    return next();
  } catch (e) {
    console.error("[albumsGuard] error", e);
    return next(buildNotFoundTarget(to));
  }
};
